import { render, staticRenderFns } from "./SeparatingMixtureLab.vue?vue&type=template&id=499aae1b&"
import script from "./SeparatingMixtureLab.vue?vue&type=script&lang=js&"
export * from "./SeparatingMixtureLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports